import React from 'react'
import './Button.scss'

class Button extends React.Component {
  render() {
    const { text, onClick, disabled, image } = this.props
    return (
      <div className={`button ${disabled ? 'disabled' : null}`} onClick={onClick} type='submit' role='div'>
        {text}
        {image &&
          <img className='image' src={image} alt="text" />
        }
      </div>
    )
  }
}

export default Button
